import { NodeViewProps, NodeViewWrapper } from '@tiptap/react';
import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { TextAreaField } from '../../../../TextAreaField';
import { CloseWrapper, useBlockToolInputFocus, useNodeAttributeValue } from '../../helpers';

import classNames from 'classnames';
import classes from './CodeNodeView.module.scss';

export const CodeNodeView: FunctionComponent<NodeViewProps> = ({
  editor,
  node,
  getPos,
  updateAttributes,
}) => {
  const { t } = useTranslation();

  const { onBlockInputFocus } = useBlockToolInputFocus({ editor, getPos });

  const { code } = node.attrs;

  const { value: codeValue, changeHandler: codeChangeHandler } = useNodeAttributeValue({
    value: code,
    onChange: (value) => updateAttributes({ code: value }),
  });

  return (
    <NodeViewWrapper as={'div'} className={classNames(classes['code'])}>
      <CloseWrapper editor={editor} node={node} getPos={getPos}>
        <TextAreaField
          placeholder={t('richTextEditor.code-config-placeholder')}
          value={codeValue}
          onChange={({ target }) => codeChangeHandler(target.value)}
          onFocus={onBlockInputFocus}
          minRows={2}
        />
      </CloseWrapper>
    </NodeViewWrapper>
  );
};
